import 'css-chunksrc/client/scenes/wbs/attachmentsCount/styles.scss';export default {
  "commentsCount": "_commentsCount_y2n9i_1",
  "count": "_count_y2n9i_8",
  "icon": "_icon_y2n9i_14"
};